/**
 * Utility functions for handling coordinate formatting
 */

/**
 * Truncates a coordinate value to 8 decimal places
 * @param value - The coordinate value (latitude or longitude)
 * @returns The truncated coordinate value as a string, or empty string if invalid
 */
export const truncateCoordinate = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  if (isNaN(numValue)) {
    return '';
  }
  
  // Truncate to 6 decimal places
  return numValue.toFixed(6);
};

/**
 * Formats latitude and longitude coordinates for display
 * @param latitude - The latitude value
 * @param longitude - The longitude value
 * @returns Formatted coordinates object
 */
export const formatCoordinates = (latitude: string | number | null | undefined, longitude: string | number | null | undefined) => {
  return {
    latitude: truncateCoordinate(latitude),
    longitude: truncateCoordinate(longitude)
  };
}; 